export const TALLY_CUTOFF_ISO = "2026-09-01";

export function tallyApprovalStatus(voucher) {
  return String(voucher?.sync_approval_status || "").toUpperCase();
}

/** Post-September vouchers waiting in the Account Manager queue. */
export function tallyNeedsManagerApproval(voucher) {
  return tallyApprovalStatus(voucher) === "PENDING_APPROVAL";
}

export function tallyDirectSyncBlockedReason(voucher) {
  const status = tallyApprovalStatus(voucher);
  if (status === "PENDING_APPROVAL") {
    return "Awaiting Account Manager approval under Tally Approvals queue";
  }
  if (status === "REJECTED") {
    return voucher?.sync_rejection_reason || voucher?.rejection_reason || "Rejected by Account Manager";
  }
  return null;
}

export function canTallySyncApprove(user, { hasPermission, hasRole }) {
  return Boolean(
    hasPermission?.(user, "tally.sync.approve") &&
      hasRole?.(user, ["admin", "manager", "accounts_manager"]),
  );
}
